import { render, staticRenderFns } from "./TermSelection.vue?vue&type=template&id=2f158b06&"
import script from "./TermSelection.vue?vue&type=script&lang=js&"
export * from "./TermSelection.vue?vue&type=script&lang=js&"
import style0 from "./TermSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports